import { api } from '@/api/api'
import * as types from '@/vuex/types'
import importBtn from '@/Util/importantBtn'

const tableMixins = {
  components: {
    importBtn
  },
  props: {
    tab: String,
    modules: String
  },
  data() {
    return {
      deleteArr: [],
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      loading: false,
      pagination: false,
      exportloading: false,
      exportloading1: false,
      exportloading3: false
    }
  },
  mounted() {
    if (this.type != 'sonTable') {
      this.getList()
    }
  },
  methods: {
    // 选择年度
    handleUserDropdownCommand(command) {
      this.search_year = command
      this.refreshTable()
    },
    // 导出
    downloadExcel(url, data = {}) {
      this.exportloading = true
      // 参数
      var params = {
        six_manager_id: this.sixMangerId
      }
      if(this.$store.state.companyId && this.$store.state.companyId != 'null' && this.$store.state.companyId != 'undefined'){
        params.company_id = this.$store.state.companyId
      }else{
        params.company_id = null
      }
      params = { ...params, ...data }
      if (params.hasOwnProperty("page_size")) {
        delete params.page_size
      }
      if(params.hasOwnProperty("page_index")){
        delete params.page_index
      }
      this.$http.post(
        url,
        params,
        { headers: { 'Accept': 'application/octet-stream' } }
      ).then(response => {
        this.exportloading = false
        if (response.data.code !== 0) {
          this.$message({
            type: 'warning',
            message: '导出Excel文件失败：' + response.data.msg
          })
        } else {
          window.open(response.data.data['file_url'])
        }
      }).catch(error => {
        this.exportloading = false
        if (error.message.includes('timeout')) {
          this.$message({
            type: 'warning',
            message: '导出失败，可能数据量太大，请添加过滤条件'
          })
        } else {
          console.log(error)
        }
        console.log(error)
      })
    },
    archive(url, data = {}) {
      this.exportloading1 = true
      // 参数
      var params = {
        company_id: this.$store.state.companyId,
        is_archive: this.$store.state.is_archive
      }
      params = { ...params, ...data }
      this.$http.post(
        url,
        params,
        { headers: { 'Accept': 'application/octet-stream' } }
      ).then(response => {
        this.exportloading1 = false
        if (response.data.code === 0) {
          this.$message({
            type: 'success',
            message: '归档成功! '
          })
        } else {
          this.$message({
            type: 'warning',
            message: '归档失败! '
          })
        }
      }).catch(error => {
        this.exportloading1 = false
        if (error.message.includes('timeout')) {
          this.$message({
            type: 'warning',
            message: '请求超时'
          })
        } else {
          console.log(error)
        }
        console.log(error)
      })
    },
    archiveNew(url, data = {}) {
      this.exportloading3 = true
      // 参数
      var params = {
        company_id: this.$store.state.companyId,
        is_archive: this.$store.state.is_archive
      }
      params = { ...params, ...data }
      this.$http.post(
        url,
        params,
        { headers: { 'Accept': 'application/octet-stream' } }
      ).then(response => {
        this.exportloading3 = false
        if (response.data.code === 0) {
          this.$message({
            type: 'success',
            message: '归档成功! '
          })
        } else {
          this.$message({
            type: 'warning',
            message: '归档失败! '
          })
        }
      }).catch(error => {
        this.exportloading3 = false
        if (error.message.includes('timeout')) {
          this.$message({
            type: 'warning',
            message: '请求超时'
          })
        } else {
          console.log(error)
        }
        console.log(error)
      })
    },
    personFormat(person) {
      if (person) {
        let arr = person.split(',')
        let arr2 = arr.filter((item, index) => {
          return index < 3
        })
        return `${arr2.join(',')}${arr.length > 2 ? `等${arr.length}人` : ''}`
      }
      return '-'
    },
    // 表格增加按钮
    showForm() {
      this.$refs['addOrUpdateForm'].showForm()
    },
    showEditForm(row) {
      this.$refs['addOrUpdateForm'].showEditForm(row)
    },
    // 刷新操作
    refreshTable() {
      this.getList()
      this.SelectionAll = {}
    },
    deletePromise(id) {
      return new Promise((resolve, reject) => {
        this.$http.post(
          api[`delete${this.data_class}`],
          { id }
        ).then(response => {
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            this.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            })
          }
        }).catch(error => {
          console.log(error)
        })
      })
    },
    // 批量删除
    batchDelete(name) {
      if (this.deleteArr.length == 0) {
        this.$message({
          type: 'warning',
          message: `请先勾选要删除的${name}`
        })
        return
      }
      this.$confirm('请确认您是否要进行批量删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const uploadTasks = this.deleteArr.map((id) => this.deletePromise(id))
        Promise.all(uploadTasks).then(data => {
          this.refreshTable()
          this.$message({
            type: 'success',
            message: `删除成功`
          })
        })
      }).catch(() => {
      })
    },
    // 删除操作
    handleDelete(row) {
      this.$confirm('请确认您是否要删除该条数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调删除接口，刷新表格
        this.$http.post(
          api[`delete${this.data_class}`],
          { id: row.id }
        ).then(response => {
          if (response.data.code === 0) {
            this.refreshTable()
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
      })
    },
    // 获取表格数据
    getList(newParams) {
      this.loading = true
      let params = {
        year: this.search_year ? this.search_year : null
      }
      if (this.$store.state.companyId && this.$store.state.companyId !== 'null' && this.data_class != 'CheckTableDB') { // 特判检查清单不传companyId
        params.company_id = this.$store.state.companyId
      }
      if (this.pagination) {
        params.page_index = this.currentPage
        params.page_size = this.pageSize ? this.pageSize : 10
      }
      if (newParams) {
        for (let key in newParams) {
          params[key] = newParams[key]
        }
      }
      if (this.handleNewParams) {
        let myParams = this.handleNewParams()
        for (let key in myParams) {
          params[key] = myParams[key]
        }
      }
      this.$http.post(
        api[`get${this.data_class}List`],
        params
      ).then(response => {
        this.tableData = response.data.data
        if (this.pagination && this.tableData.length > 0) {
          this.totalCount = response.data.page_info.total_num
        } else {
          this.totalCount = 0
        }
        if (this.initTableData) {
          this.initTableData(response)
        }
        setTimeout(() => {
          this.loading = false
        }, 400)
      }).catch((error) => {
        console.log(error)
      })
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val
      this.refreshTable()
    },
    // 切换分页数
    handleSizeChange(val) {
      this.pageSize = val
      this.refreshTable()
    },
    // 表格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return {
        padding: '8px 0',
        color: '#000'
      }
    },
    // 批量删除表格数据
    batchDeleteTable() {
      let riskListArr = []
      for (let key in this.SelectionAll) {
        riskListArr.push(key)
      }
      if (riskListArr.length === 0) {
        this.$message({
          type: 'warning',
          message: `请先勾选要删除的信息`
        })
        return
      }
      this.$confirm('请确认您是否要删除选中的信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调删除接口，刷新表格
        this.$http.post(
          api[`delete${this.delete_class}ByBatch`],
          {
            company_id: this.$store.state.companyId,
            [`${this.id_list}_id_list`]: riskListArr.join(',')
          }
        ).then(response => {
          if (response.data.code === 0) {
            this.refreshTable()
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
// 表单mixins
const dialogMixins = {
  props: {
    tab: String,
    modules: String,
    data_class: String
  },
  data() {
    return {
      dialogFormVisible: false,
      dataId: null,
      oldShowForm: {},
      oldEditForm: {},
      rowData: null
    }
  },
  mounted() {
    this.oldShowForm = { ...this.ruleForm }
  },
  computed: {
    formTitle() {
      return this.dataId ? '编辑' : '新增'
    }
  },
  methods: {
    // 返回树数组
    getTreeArr(value, key, treeData) {
      let arr = []
      let returnArr = []
      let depth = 0
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = (childrenData[j][key])
          if (childrenData[j][key] === value) {
            returnArr = arr.slice(0, depthN + 1) // 将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }
      return childrenEach(treeData, depth)
    },
    showFileDetail(url) {
      this.dialogVisible2 = true
      // window.open(row.url)
      this.url = url
    },
    checkRules(key) {
      this.$refs.form.validateField(key)
    },
    // 显示新用户表单对话框
    showForm(param) {
      this.dialogFormVisible = true
      this.dataId = null
      for (let key in this.ruleForm) {
        this.ruleForm[key] = this.oldShowForm[key]
      }
      // if (param) {
      //   for (let key in param) {
      //     this.ruleForm[key] = param[key]
      //   }
      // }
      if (this.handleshowForm) {
        this.handleshowForm(param)
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          // 清楚数据校验信息
          this.$refs['form'].clearValidate()
        }
      })
      // 需要初始值的情况
      if (this.handleSetValue) {
        for (let key in this.handleSetValue()) {
          this.ruleForm[key] = this.handleSetValue()[key]
        }
      }
    },
    // 显示编辑用户表单对话框
    showEditForm(rowData, param) {
      this.dialogFormVisible = true
      this.dataId = rowData.id
      this.rowData = rowData
      for (let key in this.ruleForm) {
        this.ruleForm[key] = rowData[key]
        if (rowData[key] === null) {
          this.ruleForm[key] = undefined
        }
      }
      if (this.handleRuleForm) {
        this.handleRuleForm(rowData, param)
      }
      this.oldEditForm = { ...this.ruleForm }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          // 清楚数据校验信息
          this.$refs['form'].clearValidate()
        }
      })
    },
    submitForm(needCompanyId) { // 默认需要传companyId,检查清单特判不用，其他的不知道要不要
      if (this.checkForm) {
        if (!this.checkForm()) {
          return
        }
      }
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          return
        }
        let params = this.handleParams ? this.handleParams() : { ...this.ruleForm }
        if (this.dataId) {
          params.id = this.dataId
        }
        if (this.$store.state.companyId && this.$store.state.companyId !== 'null' && needCompanyId) {
          params.company_id = this.$store.state.companyId
        }
        this.$http.post(api[`addOrUpdate${this.data_class}`], params).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: params.id ? '修改成功' : '新增成功',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.$emit('refreshTable')
          } else {
            this.$message({
              message: params.id ? `修改失败 ${res.data.msg}` : `新增失败 ${res.data.msg}`,
              type: 'warning'
            })
          }
        })
      })
    },
    dataChange(val, type, data) {
      for (let item of data) {
        if (val == item.id) {
          if (type == 'name') {
            this.ruleForm[`name`] = item.name
          } else {
            this.ruleForm[`${type}_name`] = item.name
          }
        }
      }
    },
    dataMultipleChange(val, type, data) {
      let arr = val.map(item => {
        for (let i of data) {
          if (i.id == item) {
            return i.name
          }
        }
      })
      this.ruleForm[`${type}_name`] = arr.join(',')
    },
    // 隐藏对话框
    hideForm() {
      this.dialogFormVisible = false
    },
    // 打开对话框的事件响应
    handleDialogOpen() {
      if (this.$refs['form']) {
        // 清楚数据校验信息
        this.$refs['form'].clearValidate()
      }
    }
  }
}

// 上传文件用的mixins
const fileMixins = {
  data() {
    return {
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'file',
        role: 4
      }
    }
  },
  methods: {
    // 文件处理 --start
    handleAvatarSuccess(res, file, key) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '上传成功'
        })
        this.ruleForm[key] = res.data['url']
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(types.LOGOUT)
        this.$router.replace({ name: 'login' })
      } else {
        this.$message({
          type: 'warning',
          message: '上传失败'
        })
      }
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleFileRemove(res, file, key) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.files = []
        for (let item of file) {
          this.files.push(item.url)
        }
        this.ruleForm[key] = this.files.join(',')
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(types.LOGOUT)
        this.$router.replace({ name: 'login' })
      } else {
        this.$message({
          type: 'warning',
          message: '删除失败'
        })
      }
    },
    // handleRemove(file, fileList, key) {
    //   this.images = []
    //   for (let item of fileList) {
    //     this.images.push(item.url)
    //   }
    //   this.ruleForm[key] = this.images.join(',')
    // },
    beforeFileUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 200
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 200MB!')
      }
      return isLt5M
    },
    beforeAvatarUpload(file) {
      // const isJPGorPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt5M = file.size / 1024 / 1024 < 200
      // if (!isJPGorPNG) {
      //   this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      // }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 200MB!')
      }
      return isLt5M
    }
    // 文件处理 --end
  }
}
// 上传图片的mixins
const imageMixins = {
  data() {
    return {
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'image',
        role: 4
      }
    }
  },
  methods: {
    // 图片处理
    handleAvatarSuccess(res, file, key) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '图片上传成功'
        })
        this.ruleForm[key] = res.data['url']
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(types.LOGOUT)
        this.$router.replace({ name: 'login' })
      } else {
        this.$message({
          type: 'warning',
          message: '图片上传失败'
        })
      }
    },
    beforeAvatarUpload(file) {
      const isJPGorPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt5M = file.size / 1024 / 1024 < 200
      if (!isJPGorPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 200MB!')
      }
      return isJPGorPNG && isLt5M
    }
  }
}
// 多图片的mixins
const multipleImgMixins = {
  data() {
    return {
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'image',
        role: 4
      }
    }
  },
  methods: {
    handleRemove(file, fileList, key) {
      this.images = []
      for (let item of fileList) {
        this.images.push(item.url)
      }
      this.ruleForm[key] = this.images.join(',')
    },
    handlepicture(res, file, fileList, key) {
      if (res.code === 0) {
        let image = [...fileList]
        this.ruleForm[key] = []
        for (let item of image) {
          if (item.response) {
            this.ruleForm[key].push(item.response.data.url)
          } else {
            this.ruleForm[key].push(item.url)
          }
        }
        this.ruleForm[key] = this.ruleForm[key].join(',')
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(types.LOGOUT)
        this.$router.replace({ name: 'login' })
      } else {
        this.$message({
          type: 'warning',
          message: '图片上传失败 ' + res.data.msg
        })
      }
    },
    // 图片处理
    handlepictureSuccess(res, file, fileList, key) {
      if (res.code === 0) {
        let image = [...fileList]
        let imagestr = []
        this.ruleForm[key] = []
        for (let item of image) {
          if (item.response) {
            this.ruleForm[key].push({ url: item.response.data.url })
            imagestr.push(item.response.data.url)
          } else {
            this.ruleForm[key].push({ url: item.url })
            imagestr.push(item.url)
          }
        }
        this.image_url = imagestr.join('|')
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(types.LOGOUT)
        this.$router.replace({ name: 'login' })
      } else {
        this.$message({
          type: 'warning',
          message: '图片上传失败 ' + res.data.msg
        })
      }
    },
    beforeAvatarUpload(file) {
      const isJPGorPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt5M = file.size / 1024 / 1024 < 200
      if (!isJPGorPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 200MB!')
      }
      return isJPGorPNG && isLt5M
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove(file, fileList, key) {
      this.$confirm(`确定移除该图片？`).then(() => {
        for (let i in fileList) {
          if (fileList[i] === file) {
            // fileList.
            fileList.splice(i, 1)
            break
          }
        }
        let image = [...fileList]
        let imagestr = []
        this.ruleForm[key] = []
        for (let item of image) {
          if (item.response) {
            this.ruleForm[key].push({ url: item.response.data.url })
            imagestr.push(item.response.data.url)
          } else {
            this.ruleForm[key].push({ url: item.url })
            imagestr.push(item.url)
          }
        }
        this.image_url = imagestr.join('|')
      }).catch(() => {
      })
      return false
    }
  }
}
// 公共数据的表格
const commonTableMixins = {
  props: {
    tab: String,
    modules: String
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    tableData() {
      return this.$store.getters[`${this.data_class.replace(this.data_class[0], this.data_class[0].toLowerCase())}Data`]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$store.dispatch(types[`GET${this.data_class.toUpperCase()}DATA`]).then(res => {
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    // 表格增加按钮
    showForm() {
      this.$refs['addOrUpdateForm'].showForm()
    },
    showEditForm(row) {
      this.$refs['addOrUpdateForm'].showEditForm(row)
    },
    // 刷新操作
    refreshTable(params) {
      this.getList()
    },
    // 删除操作
    handleDelete(row) {
      this.$confirm('请确认您是否要删除该条数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调删除接口，刷新表格
        this.$http.post(
          api[`delete${this.data_class}`],
          { id: row.id }
        ).then(response => {
          if (response.data.code === 0) {
            this.refreshTable()
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
      })
    },
    // 表格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return {
        padding: '8px 0',
        color: '#000'
      }
    }
  }
}
//
const infoMixins = {
  methods: {
    // 保存操作 --start
    saveCompanyInfo() {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          this.$message({
            message: '请完善信息',
            type: 'warning'
          })
          return
        }
        this.saveData()
      })
    },
    async saveData() {
      let params = {
        company_id: this.$store.state.companyId,
        is_update_info: 1
      }
      for (let key in this.ruleForm) {
        if (this.ruleForm[key] !== null) {
          params[key] = this.ruleForm[key]
        }
      }
      let res = await this.$http.post(api.addOrUpdate, params)
      if (res.data.code === 0) {
        this.$message({ message: '保存成功', type: 'success' })
      } else {
        this.$message({ message: res.data.msg, type: 'warining' })
      }
    }
  }
}

export {
  tableMixins,
  dialogMixins,
  fileMixins,
  imageMixins,
  multipleImgMixins,
  commonTableMixins,
  infoMixins
}



// WEBPACK FOOTER //
// ./src/mixins/qiboMixins.js